module.exports = __webpack_public_path__ + "static/media/4th.f8e05468.jpg";